import React, { Component } from "react";
import mailIcon from "../images/mail-icon.svg";

export default class MailButton extends Component {
    constructor(props) {
      super(props);
      this.mail_address = props.attributes;
    }

    render() {
        var url = 'mailto:';
        url += this.mail_address;
        return (
            <a href={url} className="mail_icon_button">
                <img src={mailIcon} width="50" height="50" />
            </a>       
        );
    }
  }
  